import i18n from '../../modules/i18n';

export default {
  seconds: [
    i18n.t('decls.second.form1', '', 'секунда'),
    i18n.t('decls.second.form2', '', 'секунды'),
    i18n.t('decls.second.form3', '', 'секунд'),
  ],
  minutes: [
    i18n.t('decls.min.form1', '', 'минута'),
    i18n.t('decls.min.form2', '', 'минуты'),
    i18n.t('decls.min.form3', '', 'минут'),
  ],
  hours: [
    i18n.t('decls.hour.form1', '', 'час'),
    i18n.t('decls.hour.form2', '', 'часа'),
    i18n.t('decls.hour.form3', '', 'часов'),
  ],
  days: [
    i18n.t('decls.day.form1', '', 'день'),
    i18n.t('decls.day.form2', '', 'дня'),
    i18n.t('decls.day.form3', '', 'дней'),
  ],
  months: [
    i18n.t('decls.month.form1', '', 'месяц'),
    i18n.t('decls.month.form2', '', 'месяца'),
    i18n.t('decls.month.form3', '', 'месяцев'),
  ],
};
